// Shared constants for the chat composer surfaces
export const COMPOSER_FORMAT_TOGGLE_STORAGE_KEY = 'groups_composer_formatting_active';

const composerConstants = {
  COMPOSER_FORMAT_TOGGLE_STORAGE_KEY,
};

export default composerConstants;
